import { useRouter } from 'next/navigation';

import { RibbonButton } from '@/components/atomic/atoms';
import {
  captureGTMEventCTAClick,
  GTM_EVENTS_CTA_NAME,
  PAGE_NAME
} from '@/lib/gtm';

const SectionActionButton = ({
  buttonText,
  isGTMEventCTAClick = false,
  isOpenInSameTab = false,
  url
}) => {
  const Router = useRouter();
  return (
    <div className='flex flex-row items-center justify-center mb-10'>
      <div className='flex flex-row justify-content-center place-content-center'>
        <RibbonButton
          buttonText={buttonText}
          onClick={() => {
            isGTMEventCTAClick &&
              captureGTMEventCTAClick({
                ctaName: GTM_EVENTS_CTA_NAME.PLAN_YOUR_EVENT,
                pageName: PAGE_NAME.HOME_PAGE.label
              });
            return isOpenInSameTab
              ? Router.push(url)
              : window.open(url, '_blank');
          }}
        />
      </div>
    </div>
  );
};

export default SectionActionButton;
